import React, { useMemo } from 'react';
import SkeletonItems from '../SkeletonItems';
import { ProductReadModel } from '~types/api';
import HorizontalSlider from '~view/widgets/HorizontalSlider';
import { useInstantSearch } from '~view/widgets/InstantSearchProvider';
import { ProductListViewItemByAlgolia } from '~view/widgets/ProductListViewItemByAlgolia';

const Items: React.FC<{ productIds: string[] }> = ({ productIds }) => {
  const {
    hits,
    searching,
    isSearchStalled,
  } = useInstantSearch<ProductReadModel>();

  const products = useMemo(
    () =>
      productIds
        .map((productId) => hits?.find((product) => product.id === productId))
        .filter((product) => product),
    [productIds, hits]
  );

  if (searching && !isSearchStalled) {
    return <SkeletonItems />;
  }

  if (!products?.length) {
    return null;
  }

  return (
    <div className="border-bottom mb-5">
      <div>
        <h5 className="font-weight-bold mb-4">こちらもいかがですか？</h5>
      </div>
      <HorizontalSlider xs={2}>
        {products.map((product, i) => (
          <ProductListViewItemByAlgolia
            key={product!.id}
            productJson={product!}
            index={i}
            col={false}
            border
          />
        ))}
      </HorizontalSlider>
    </div>
  );
};

export default Items;
